module.exports = __webpack_public_path__ + "static/media/street.77240149.gif";